<template>
    <Head title="Terms of Service" />

    <div class="font-sans text-gray-900 antialiased">
        <div class="pt-4 bg-gray-100">
            <div class="min-h-screen flex flex-col items-center pt-6 sm:pt-0">
                <div>
                    <logo-app class="w-auto" />
                </div>

                <div
                    class="
                        w-full
                        sm:max-w-2xl
                        mt-6
                        p-6
                        bg-white
                        shadow-md
                        overflow-hidden
                        sm:rounded-lg
                        prose
                    "
                >
                    <body>
                    <h1>Syarat dan Ketentuan Penggunaan Aplikasi tumbas.apps.undip.ac.id</h1>

                    <p>Terakhir diperbarui: [Tanggal]</p>

                    <p>Selamat datang di aplikasi pengadaan tumbas.apps.undip.ac.id. Sebelum Anda mulai menggunakan aplikasi ini, harap baca dengan seksama syarat dan ketentuan penggunaan di bawah ini. Dengan mengakses atau menggunakan aplikasi ini, Anda dianggap telah membaca, memahami, dan menyetujui untuk terikat oleh syarat dan ketentuan yang tercantum di bawah ini. Jika Anda tidak setuju dengan salah satu ketentuan ini, harap untuk tidak melanjutkan penggunaan aplikasi ini.</p>

                    <h2>1. Penggunaan Aplikasi</h2>

                    <p>1.1. Aplikasi tumbas.apps.undip.ac.id adalah sebuah platform yang disediakan oleh Universitas Diponegoro ("Undip") untuk mengelola proses pengadaan berbagai barang dan jasa.</p>

                    <p>1.2. Pengguna aplikasi ini diharapkan adalah pihak yang memiliki hubungan resmi dengan Undip, termasuk namun tidak terbatas pada staf, dosen, mahasiswa, dan pihak-pihak terkait.</p>

                    <p>1.3. Anda setuju untuk menggunakan aplikasi ini sesuai dengan semua hukum dan peraturan yang berlaku serta dengan cara yang etis dan bertanggung jawab.</p>

                    <h2>2. Informasi Pribadi</h2>

                    <p>2.1. Dalam proses penggunaan aplikasi, Anda mungkin diminta untuk memberikan informasi pribadi. Pengumpulan, penggunaan, dan penyimpanan informasi pribadi akan diatur oleh Kebijakan Privasi aplikasi ini.</p>

                    <h2>3. Keamanan</h2>

                    <p>3.1. Anda bertanggung jawab untuk menjaga kerahasiaan akun Anda dan informasi login yang diberikan kepada Anda untuk mengakses aplikasi ini.</p>

                    <p>3.2. Anda tidak diperkenankan untuk menggunakan aplikasi ini untuk tujuan yang melanggar hukum atau merugikan pihak lain.</p>

                    <h2>4. Perubahan dan Penutupan Aplikasi</h2>

                    <p>4.1. Undip berhak untuk mengubah atau menutup aplikasi ini, termasuk mengubah atau menghentikan fitur-fitur yang ada di dalamnya tanpa pemberitahuan sebelumnya.</p>

                    <h2>5. Tanggung Jawab</h2>

                    <p>5.1. Anda setuju bahwa penggunaan aplikasi ini sepenuhnya menjadi risiko Anda sendiri. Undip tidak bertanggung jawab atas segala kerugian atau kerusakan yang mungkin timbul dari penggunaan aplikasi ini.</p>

                    <h2>6. Perubahan Syarat dan Ketentuan</h2>

                    <p>6.1. Undip berhak untuk mengubah syarat dan ketentuan ini sesuai kebijakannya. Perubahan akan diberitahukan melalui pembaruan pada aplikasi atau melalui komunikasi lainnya kepada pengguna yang terdaftar.</p>

                    <p>Dengan mengakses atau menggunakan aplikasi tumbas.apps.undip.ac.id, Anda menyatakan bahwa Anda telah membaca, memahami, dan menyetujui syarat dan ketentuan penggunaan ini. Jika Anda tidak setuju, harap untuk tidak melanjutkan penggunaan aplikasi ini.</p>

                    <p>Harap dicatat bahwa syarat dan ketentuan ini adalah perjanjian antara Anda dan Universitas Diponegoro sehubungan dengan penggunaan aplikasi tumbas.apps.undip.ac.id.</p>

                    <p>Jika Anda memiliki pertanyaan atau klarifikasi mengenai syarat dan ketentuan ini, silakan hubungi [Kontak].</p>
                    </body>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent } from "vue";
import { Head } from "@inertiajs/inertia-vue3";
import JetAuthenticationCardLogo from "@/Jetstream/AuthenticationCardLogo.vue";
import LogoApp from "@/Logo/LogoApp.vue";

export default defineComponent({
    props: ["terms"],

    components: {
        Head,
        JetAuthenticationCardLogo,
        LogoApp,
    },
});
</script>
